import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { useTicketsSelected, useSaturated } from '@/store';
import TSI from '../ticket/TicketSelectedItem';
import PromotionButton from '@/sections/promotion/PromotionButton';
import PromotionBanner from '@/sections/promotion/PromotionBanner';

function BookingSummary({ changeView = () => { } }) {
  const { t } = useTranslation();
  const { ticketsSelected } = useTicketsSelected();
  const { isEnabled } = useSaturated();

  useEffect(() => {
    if (ticketsSelected.length < 1) {
      changeView('home');
    }
  }, [ticketsSelected]);

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Stack sx={{ width: '75%' }}>
          {ticketsSelected.length > 0 && (
            <Box
              sx={{
                width: '100%',
                mt: 2,
              }}
            >
              <Typography variant="h5" component="div">
                {t('checkout.home.cart.title')}
              </Typography>
              <Typography
                variant="caption2"
                component="div"
                sx={{ color: (theme) => theme.palette.grey[500] }}
              >
                {t('checkout.home.cart.desc')}
              </Typography>
            </Box>
          )}
          {!ticketsSelected.length && (
            <nBox
              sx={{
                width: '100%',
                mt: 2,
              }}
            >
              <Typography
                variant="caption2"
                component="div"
                sx={{ color: (theme) => theme.palette.grey[500] }}
              >
                {t('checkout.home.cart.selectFromMap')}
              </Typography>
            </nBox>
          )}
        </Stack>
        {/* Boton Promotion */}

        <Stack alignItems="center" justifyContent="flex-end" direction="row" sx={{
          'width': '60%',
          'mt': 2,
          '& .MuiButtonBase-root': {
            zIndex: 0,
          },
        }}>
          <PromotionButton rounded />
        </Stack>
      </Stack>

      <Box
        sx={{
          width: '100%',
        }}
      >
        <PromotionBanner />
      </Box>

      <Stack
        sx={{
          width: '100%',
          mt: 2,
        }}
        gap={2}
      >
        {ticketsSelected
          .sort((a, b) => {
            const aId = a.id.toUpperCase();
            const bId = b.id.toUpperCase();

            if (aId < bId) return -1;
            if (aId > bId) return 1;

            return 0;
          })
          .map((ticketSelected) => (
            <TSI key={ticketSelected.id} ticket={ticketSelected} withMap />
          ))}
      </Stack>
      {!isEnabled && ticketsSelected.length > 0 && (
        <Box
          sx={{
            width: '100%',
            mt: 2,
          }}
        >
          <Typography
            variant="caption2"
            component="div"
            sx={{ color: (theme) => theme.palette.grey[400] }}
          >
            {t('checkout.home.cart.instruction')}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default BookingSummary;
